import { DELETE } from 'shared/components/vxl/NumberPad/NumberPadButton';

// Utility function to truncate a number to decimal places
export const truncateToDecimalPlaces = (
  value: number,
  decimalPlaces: number,
): string => {
  // Convert number to string and split into integer and fractional parts
  const [integerPart, fractionalPart = ''] = value.toString().split('.');

  const formattedFractionalPart = (fractionalPart + '00').slice(
    0,
    decimalPlaces,
  );

  return `${integerPart}.${formattedFractionalPart}`;
};

// Function to transform the amount based on digit input
export const transformAmount = (amount: number, digit: number): number => {
  const transformedAmount = (amount + 0.001 * digit) * 10;
  return transformedAmount;
};

// Helper function to safely parse float values from strings or numbers
export const parseToFloat = (value: string | number | undefined): number => {
  if (typeof value === 'undefined') {
    return 0;
  }

  if (typeof value === 'number') {
    return isNaN(value) ? 0 : value;
  }
  const parsed = parseFloat(value);
  return isNaN(parsed) ? 0 : parsed;
};

export const applyKeyToAmount = (
  amount: string,
  key: string,
): string | undefined => {
  // Helper function to parse and format the amount
  const formatAmount = (amount: number) => amount.toFixed(2);

  if (key === DELETE || key === 'Backspace') {
    // Update amount by dividing by 10 and formatting
    const parsedPrev = parseToFloat(amount);
    const formattedAmount = truncateToDecimalPlaces(parsedPrev / 10, 2);
    return formattedAmount;
  }
  let currentAmount = parseToFloat(amount);
  if (key === '00') {
    // Parse the current amount and the new value once
    const newValue = parseToFloat(key);

    // Convert currentAmount to a string once
    const currentAmountStr = currentAmount.toString();
    const integerPartLength = currentAmountStr?.split('.')[0].length;

    if (integerPartLength <= 6) {
      const newTransferAmount = transformAmount(currentAmount, newValue);
      currentAmount = newTransferAmount;
    }
  }
  // Parse the current amount and the new value once
  const newValue = parseToFloat(key);

  // Convert currentAmount to a string once
  const currentAmountStr = currentAmount.toString();
  const integerPartLength = currentAmountStr?.split('.')[0].length;

  if (integerPartLength <= 6) {
    const newTransferAmount = transformAmount(currentAmount, newValue);
    const formattedAmount = formatAmount(newTransferAmount);
    return formattedAmount;
  }
  return undefined;
};
